import { bindToApp, bindToServer } from './server/client.ts';

export const TestClient = {
    bindToApp: bindToApp,
    bindToServer: bindToServer
}
